import { useContext } from 'react';
import { BreakpointsContext } from './breakpoints-context';
/**
 * Provides breakpoints for the app, provided to the theme wrapper.
 */

export var useBreakpoints = function useBreakpoints() {
  return useContext(BreakpointsContext);
};